import { render, staticRenderFns } from "./InPractisePerf.vue?vue&type=template&id=608e2fbe&scoped=true&"
import script from "./InPractisePerf.vue?vue&type=script&lang=ts&"
export * from "./InPractisePerf.vue?vue&type=script&lang=ts&"
import style0 from "./InPractisePerf.vue?vue&type=style&index=0&id=608e2fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e2fbe",
  null
  
)

export default component.exports